import Switch from 'components/Switch';
import { FRIDAY, MainDrawScheduleCode, TUESDAY } from 'constants/Draw';
import { extendClassName } from 'utils/common';
import { colors } from 'utils/constants';

interface ToggleDrawCodeProps {
  defaultDrawCode?: MainDrawScheduleCode;
  selectedDrawCode: MainDrawScheduleCode;
  handleToggle: () => void;
}

const ToggleDrawCode = ({
  defaultDrawCode = FRIDAY,
  selectedDrawCode,
  handleToggle,
}: ToggleDrawCodeProps) => {
  const secondDrawCode = defaultDrawCode === FRIDAY ? TUESDAY : FRIDAY;

  return (
    <div className="toggleDrawCode flexRow">
      <p
        className={extendClassName(
          'toggleLabel',
          selectedDrawCode === secondDrawCode ? 'selected' : ''
        )}
      >
        {secondDrawCode}
      </p>
      <Switch
        id={'toggle-draw-code'}
        enabled={selectedDrawCode === defaultDrawCode}
        design2
        onToggle={handleToggle}
        style={{ margin: '0 1.5em' }}
      />
      <p
        className={extendClassName(
          'toggleLabel',
          selectedDrawCode === defaultDrawCode ? 'selected' : ''
        )}
      >
        {defaultDrawCode}
      </p>

      <style jsx>
        {`
          .toggleDrawCode {
            margin: 1em 0;
          }

          p.toggleLabel {
            margin: 0;
            font-size: 1.2em;
            font-weight: 700;
            color: #9b9b9b;
            text-transform: lowercase;
          }

          p.toggleLabel::first-letter {
            text-transform: uppercase;
          }

          p.toggleLabel.selected {
            color: ${colors.primaryBrandGray};
          }
        `}
      </style>
    </div>
  );
};

export default ToggleDrawCode;
